import dayjs from 'dayjs';
import { useMemo } from 'react';

interface FetchResponse<T> {
  time: string;
  data: T;
}

export const useRevalidate = <T>(key: string, seconds: number) => {
  const results = useMemo(() => {
    let data: T | null = null;
    const prevFetchResponseString = localStorage.getItem(key);
    if (prevFetchResponseString) {
      const prevFetchResponse = JSON.parse(
        prevFetchResponseString,
      ) as FetchResponse<T>;
      if (
        dayjs().add(-seconds, 'seconds').isBefore(dayjs(prevFetchResponse.time))
      ) {
        data = prevFetchResponse.data;
      }
    }
    const mutate = (newData: T) => {
      const res: FetchResponse<T> = {
        time: dayjs().toISOString(),
        data: newData,
      };
      localStorage.setItem(key, JSON.stringify(res));
    };
    return { data, mutate };
  }, [key]);

  return results;
};
